import { setUserDetailsData, resetUserDetailsData } from '../../../redux/userDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import UserDetailsContent from './userDetailsContent';
import UserDetailsHeader from './userDetailsHeader';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const UserDetails = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const fetchUsereDetails = useCallback(async () => {
    try {
      const response = await axios.get(`user/${id}`);
      if (response.status === 200 || response.status === 201) {
        dispatch(setUserDetailsData(response.data));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error Fetching user:', error);
      CustomErrorLogger(error, 'fetch user in UserDetails');
    }
  }, [id, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchUsereDetails()
    return () => {
      dispatch(resetUserDetailsData());
    };
  }, [fetchUsereDetails, id, dispatch]);

  return (
    <Box>
      {loading ?
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <CircularProgress
            sx={{
              '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
            }}
          />
        </Box>
        :
        <Box>
          <UserDetailsHeader />
          <SuccessfullModifyDialog />
          <UserDetailsContent />
        </Box>
      }
    </Box>
  );
}

export default UserDetails;